/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.7.0.0 (NJsonSchema v10.1.24.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import moment from 'moment';

export interface IClient {
  /**
   * @param body (optional) 
   * @return Success
   */
  login(body?: LoginCredentials | null | undefined): Promise<void>;
  /**
   * @return Success
   */
  logout(): Promise<void>;
  /**
   * @return Success
   */
  context(): Promise<void>;
  /**
   * @param body (optional) 
   * @return Success
   */
  token(body?: LoginCredentials | null | undefined): Promise<void>;
  /**
   * @param returnUrl (optional) 
   * @return Success
   */
  account(returnUrl?: string | null | undefined): Promise<void>;
  /**
   * @return Success
   */
  checklistAreas_GetAll(): Promise<ChecklistAreaDto[]>;
  /**
   * @param body (optional) 
   * @return Success
   */
  checklistAreas_Post(body?: ChecklistAreaDto | null | undefined): Promise<ChecklistAreaDto>;
  /**
   * @return Success
   */
  checklistAreas_GetById(id: number): Promise<ChecklistAreaDto>;
  /**
   * @param body (optional) 
   * @return Success
   */
  checklistAreas_Put(id: number, body?: ChecklistAreaDto | null | undefined): Promise<void>;
  /**
   * @param body (optional) 
   * @return Success
   */
  checklistAreas_Patch(id: number, body?: Operation[] | null | undefined): Promise<ChecklistAreaDto>;
  /**
   * @return Success
   */
  checklistAreas_Delete(id: number): Promise<ChecklistAreaDto>;
  /**
   * @param search (optional) 
   * @param template (optional) 
   * @param archived (optional) 
   * @param facilityCode (optional) 
   * @param projectType (optional) 
   * @return Success
   */
  checklistProjects_GetAll(search?: string | null | undefined, template?: boolean | undefined, archived?: boolean | undefined, facilityCode?: string | null | undefined, projectType?: ChecklistProjectType | null | undefined): Promise<ChecklistProjectDto[]>;
  /**
   * @param body (optional) 
   * @return Success
   */
  checklistProjects_Post(body?: ChecklistProjectDto | null | undefined): Promise<ChecklistProjectDto>;
  /**
   * @param details (optional) 
   * @return Success
   */
  checklistProjects_GetById(id: number, details?: boolean | undefined): Promise<ChecklistProjectDto>;
  /**
   * @param body (optional) 
   * @return Success
   */
  checklistProjects_Put(id: number, body?: ChecklistProjectDto | null | undefined): Promise<void>;
  /**
   * @param body (optional) 
   * @return Success
   */
  checklistProjects_Patch(id: number, body?: Operation[] | null | undefined): Promise<ChecklistProjectDto>;
  /**
   * @return Success
   */
  checklistProjects_Delete(id: number): Promise<ChecklistProjectDto>;
  /**
   * @return Success
   */
  checklistProjects_Details(id: number): Promise<ChecklistProjectDto>;
  /**
   * @param newProjectName (optional) 
   * @param asTemplate (optional) 
   * @param facilityCode (optional) 
   * @param projectType (optional) 
   * @return Success
   */
  checklistProjects_CloneTemplate(id: number, newProjectName?: string | null | undefined, asTemplate?: boolean | undefined, facilityCode?: string | null | undefined, projectType?: ChecklistProjectType | undefined): Promise<ChecklistProjectDto>;
  /**
   * @param checklistType (optional) 
   * @return Success
   */
  checklists_GetAll(checklistType?: ChecklistType | undefined): Promise<ChecklistDto[]>;
  /**
   * @param body (optional) 
   * @return Success
   */
  checklists_Post(body?: ChecklistDto | null | undefined): Promise<ChecklistDto>;
  /**
   * @param details (optional) 
   * @return Success
   */
  checklists_GetById(id: number, details?: boolean | undefined): Promise<ChecklistDto>;
  /**
   * @param body (optional) 
   * @return Success
   */
  checklists_Put(id: number, body?: ChecklistDto | null | undefined): Promise<void>;
  /**
   * @param body (optional) 
   * @return Success
   */
  checklists_Patch(id: number, body?: Operation[] | null | undefined): Promise<ChecklistDto>;
  /**
   * @return Success
   */
  checklists_Delete(id: number): Promise<ChecklistDto>;
  /**
   * @param newChecklistName (optional) 
   * @return Success
   */
  checklists_CreateTemplateFromChecklist(id: number, newChecklistName?: string | null | undefined): Promise<RepetitiveChecklistDto>;
  /**
   * @return Success
   */
  dWMachine_GetAll(): Promise<MachineDto[]>;
  /**
   * @return Success
   */
  dWMachine_Get(facilityCode: string | null): Promise<MachineDto[]>;
  /**
   * @return Success
   */
  dWPlant_GetAll(): Promise<FacilityDto[]>;
  /**
   * @return Success
   */
  dWPlant_GetByFacilityCode(facilityCode: string | null): Promise<FacilityDto>;
  /**
   * @param includeArchived (optional) 
   * @return Success
   */
  facilities_GetAll(includeArchived?: boolean | undefined): Promise<FacilityDto[]>;
  /**
   * @param body (optional) 
   * @return Success
   */
  facilities_Post(body?: FacilityDto | null | undefined): Promise<FacilityDto>;
  /**
   * @return Success
   */
  facilities_GetByFacilityCode(facilityCode: string | null): Promise<FacilityDto>;
  /**
   * @param body (optional) 
   * @return Success
   */
  facilities_Put(facilityCode: string | null, body?: FacilityDto | null | undefined): Promise<void>;
  /**
   * @param body (optional) 
   * @return Success
   */
  facilities_Patch(facilityCode: string | null, body?: Operation[] | null | undefined): Promise<void>;
  /**
   * @param questionId (optional) 
   * @param projectId (optional) 
   * @return Success
   */
  issues_GetAll(questionId?: number | null | undefined, projectId?: number | null | undefined): Promise<IssueDto[]>;
  /**
   * @param body (optional) 
   * @return Success
   */
  issues_Post(body?: IssueDto | null | undefined): Promise<IssueDto>;
  /**
   * @return Success
   */
  issues_GetById(id: number): Promise<IssueDto>;
  /**
   * @param body (optional) 
   * @return Success
   */
  issues_Put(id: number, body?: IssueDto | null | undefined): Promise<void>;
  /**
   * @param body (optional) 
   * @return Success
   */
  issues_Patch(id: number, body?: Operation[] | null | undefined): Promise<IssueDto>;
  /**
   * @return Success
   */
  issues_Delete(id: number): Promise<IssueDto>;
  /**
   * @return Success
   */
  lookupLists_GetAll(): Promise<LookupListDto[]>;
  /**
   * @param body (optional) 
   * @return Success
   */
  lookupLists_Post(body?: LookupListDto | null | undefined): Promise<LookupListDto>;
  /**
   * @return Success
   */
  lookupLists_GetById(id: number): Promise<LookupListDto>;
  /**
   * @param body (optional) 
   * @return Success
   */
  lookupLists_Put(id: number, body?: LookupListDto | null | undefined): Promise<void>;
  /**
   * @param body (optional) 
   * @return Success
   */
  lookupLists_Patch(id: number, body?: Operation[] | null | undefined): Promise<void>;
  /**
   * @return Success
   */
  lookupLists_Delete(id: number): Promise<LookupListDto>;
  /**
   * @return Success
   */
  moreInfo_GetAll(): Promise<QuestionMoreInfoDto[]>;
  /**
   * @param body (optional) 
   * @return Success
   */
  moreInfo_Post(body?: QuestionMoreInfoDto | null | undefined): Promise<QuestionMoreInfoDto>;
  /**
   * @return Success
   */
  moreInfo_GetById(id: number): Promise<QuestionMoreInfoDto>;
  /**
   * @param body (optional) 
   * @return Success
   */
  moreInfo_Put(id: number, body?: QuestionMoreInfoDto | null | undefined): Promise<void>;
  /**
   * @param body (optional) 
   * @return Success
   */
  moreInfo_Patch(id: number, body?: Operation[] | null | undefined): Promise<void>;
  /**
   * @return Success
   */
  moreInfo_Delete(id: number): Promise<QuestionMoreInfoDto>;
  /**
   * @param areaId (optional) 
   * @return Success
   */
  questions_GetAll(areaId?: number | undefined): Promise<QuestionDto[]>;
  /**
   * @param body (optional) 
   * @return Success
   */
  questions_Post(body?: QuestionDto | null | undefined): Promise<QuestionDto>;
  /**
   * @return Success
   */
  questions_GetById(id: number): Promise<QuestionDto>;
  /**
   * @param body (optional) 
   * @return Success
   */
  questions_Put(id: number, body?: QuestionDto | null | undefined): Promise<void>;
  /**
   * @param body (optional) 
   * @return Success
   */
  questions_Patch(id: number, body?: Operation[] | null | undefined): Promise<QuestionDto>;
  /**
   * @return Success
   */
  questions_Delete(id: number): Promise<QuestionDto>;
  /**
   * @param facilityCode (optional) 
   * @param projectType (optional) 
   * @param checklistType (optional) 
   * @param archived (optional) 
   * @return Success
   */
  repetitiveChecklists_GetAll(facilityCode?: string | null | undefined, projectType?: ChecklistProjectType | null | undefined, checklistType?: ChecklistType | null | undefined, archived?: boolean | null | undefined): Promise<RepetitiveChecklistDto[]>;
  /**
   * @param body (optional) 
   * @return Success
   */
  repetitiveChecklists_Post(body?: RepetitiveChecklistDto | null | undefined): Promise<RepetitiveChecklistDto>;
  /**
   * @param details (optional) 
   * @return Success
   */
  repetitiveChecklists_GetById(id: number, details?: boolean | undefined): Promise<RepetitiveChecklistDto>;
  /**
   * @param body (optional) 
   * @return Success
   */
  repetitiveChecklists_Put(id: number, body?: RepetitiveChecklistDto | null | undefined): Promise<void>;
  /**
   * @param body (optional) 
   * @return Success
   */
  repetitiveChecklists_Patch(id: number, body?: Operation[] | null | undefined): Promise<void>;
  /**
   * @return Success
   */
  repetitiveChecklists_Delete(id: number): Promise<RepetitiveChecklistDto>;
  /**
   * @param projectId (optional) 
   * @param newChecklistName (optional) 
   * @param newType (optional) 
   * @return Success
   */
  repetitiveChecklists_CopyChecklistToProject(id: number, projectId?: number | undefined, newChecklistName?: string | null | undefined, newType?: ChecklistType | undefined): Promise<ChecklistDto>;
  /**
   * @param newChecklistName (optional) 
   * @return Success
   */
  repetitiveChecklists_DuplicateRepetitiveChecklist(id: number, newChecklistName?: string | null | undefined): Promise<RepetitiveChecklistDto>;
  /**
   * @return Success
   */
  users_GetAll(): Promise<UserDto[]>;
  /**
   * @param body (optional) 
   * @return Success
   */
  users_Post(body?: UserDto | null | undefined): Promise<UserDto>;
  /**
   * @return Success
   */
  users_GetById(id: number): Promise<UserDto>;
  /**
   * @param body (optional) 
   * @return Success
   */
  users_Put(id: number, body?: UserDto | null | undefined): Promise<void>;
  /**
   * @return Success
   */
  users_Delete(id: number): Promise<UserDto>;
}

export class Client implements IClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl ? baseUrl : "";
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  login(body?: LoginCredentials | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/Account/login";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLogin(_response);
    });
  }

  protected processLogin(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  logout(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/Account/logout";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "POST",
      url: url_,
      headers: {
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLogout(_response);
    });
  }

  protected processLogout(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  context(cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/Account/context";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processContext(_response);
    });
  }

  protected processContext(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  token(body?: LoginCredentials | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/Account/token";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processToken(_response);
    });
  }

  protected processToken(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param returnUrl (optional) 
   * @return Success
   */
  account(returnUrl?: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/Account?";
    if (returnUrl !== undefined && returnUrl !== null)
      url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processAccount(_response);
    });
  }

  protected processAccount(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  checklistAreas_GetAll(cancelToken?: CancelToken | undefined): Promise<ChecklistAreaDto[]> {
    let url_ = this.baseUrl + "/api/ChecklistAreas";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_GetAll(_response);
    });
  }

  protected processChecklistAreas_GetAll(response: AxiosResponse): Promise<ChecklistAreaDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ChecklistAreaDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistAreaDto[]>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistAreas_Post(body?: ChecklistAreaDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistAreaDto> {
    let url_ = this.baseUrl + "/api/ChecklistAreas";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_Post(_response);
    });
  }

  protected processChecklistAreas_Post(response: AxiosResponse): Promise<ChecklistAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistAreaDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistAreaDto>(<any>null);
  }

  /**
   * @return Success
   */
  checklistAreas_GetById(id: number, cancelToken?: CancelToken | undefined): Promise<ChecklistAreaDto> {
    let url_ = this.baseUrl + "/api/ChecklistAreas/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_GetById(_response);
    });
  }

  protected processChecklistAreas_GetById(response: AxiosResponse): Promise<ChecklistAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistAreaDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistAreaDto>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistAreas_Put(id: number, body?: ChecklistAreaDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/ChecklistAreas/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_Put(_response);
    });
  }

  protected processChecklistAreas_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistAreas_Patch(id: number, body?: Operation[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistAreaDto> {
    let url_ = this.baseUrl + "/api/ChecklistAreas/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_Patch(_response);
    });
  }

  protected processChecklistAreas_Patch(response: AxiosResponse): Promise<ChecklistAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistAreaDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistAreaDto>(<any>null);
  }

  /**
   * @return Success
   */
  checklistAreas_Delete(id: number, cancelToken?: CancelToken | undefined): Promise<ChecklistAreaDto> {
    let url_ = this.baseUrl + "/api/ChecklistAreas/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_Delete(_response);
    });
  }

  protected processChecklistAreas_Delete(response: AxiosResponse): Promise<ChecklistAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistAreaDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistAreaDto>(<any>null);
  }

  /**
   * @param search (optional) 
   * @param template (optional) 
   * @param archived (optional) 
   * @param facilityCode (optional) 
   * @param projectType (optional) 
   * @return Success
   */
  checklistProjects_GetAll(search?: string | null | undefined, template?: boolean | undefined, archived?: boolean | undefined, facilityCode?: string | null | undefined, projectType?: ChecklistProjectType | null | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistProjectDto[]> {
    let url_ = this.baseUrl + "/api/ChecklistProjects?";
    if (search !== undefined && search !== null)
      url_ += "search=" + encodeURIComponent("" + search) + "&";
    if (template === null)
      throw new Error("The parameter 'template' cannot be null.");
    else if (template !== undefined)
      url_ += "template=" + encodeURIComponent("" + template) + "&";
    if (archived === null)
      throw new Error("The parameter 'archived' cannot be null.");
    else if (archived !== undefined)
      url_ += "archived=" + encodeURIComponent("" + archived) + "&";
    if (facilityCode !== undefined && facilityCode !== null)
      url_ += "facilityCode=" + encodeURIComponent("" + facilityCode) + "&";
    if (projectType !== undefined && projectType !== null)
      url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_GetAll(_response);
    });
  }

  protected processChecklistProjects_GetAll(response: AxiosResponse): Promise<ChecklistProjectDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ChecklistProjectDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto[]>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistProjects_Post(body?: ChecklistProjectDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_Post(_response);
    });
  }

  protected processChecklistProjects_Post(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(<any>null);
  }

  /**
   * @param details (optional) 
   * @return Success
   */
  checklistProjects_GetById(id: number, details?: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (details === null)
      throw new Error("The parameter 'details' cannot be null.");
    else if (details !== undefined)
      url_ += "details=" + encodeURIComponent("" + details) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_GetById(_response);
    });
  }

  protected processChecklistProjects_GetById(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistProjects_Put(id: number, body?: ChecklistProjectDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_Put(_response);
    });
  }

  protected processChecklistProjects_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistProjects_Patch(id: number, body?: Operation[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_Patch(_response);
    });
  }

  protected processChecklistProjects_Patch(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(<any>null);
  }

  /**
   * @return Success
   */
  checklistProjects_Delete(id: number, cancelToken?: CancelToken | undefined): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_Delete(_response);
    });
  }

  protected processChecklistProjects_Delete(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(<any>null);
  }

  /**
   * @return Success
   */
  checklistProjects_Details(id: number, cancelToken?: CancelToken | undefined): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}/details";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_Details(_response);
    });
  }

  protected processChecklistProjects_Details(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(<any>null);
  }

  /**
   * @param newProjectName (optional) 
   * @param asTemplate (optional) 
   * @param facilityCode (optional) 
   * @param projectType (optional) 
   * @return Success
   */
  checklistProjects_CloneTemplate(id: number, newProjectName?: string | null | undefined, asTemplate?: boolean | undefined, facilityCode?: string | null | undefined, projectType?: ChecklistProjectType | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}/clone?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (newProjectName !== undefined && newProjectName !== null)
      url_ += "newProjectName=" + encodeURIComponent("" + newProjectName) + "&";
    if (asTemplate === null)
      throw new Error("The parameter 'asTemplate' cannot be null.");
    else if (asTemplate !== undefined)
      url_ += "asTemplate=" + encodeURIComponent("" + asTemplate) + "&";
    if (facilityCode !== undefined && facilityCode !== null)
      url_ += "facilityCode=" + encodeURIComponent("" + facilityCode) + "&";
    if (projectType === null)
      throw new Error("The parameter 'projectType' cannot be null.");
    else if (projectType !== undefined)
      url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_CloneTemplate(_response);
    });
  }

  protected processChecklistProjects_CloneTemplate(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(<any>null);
  }

  /**
   * @param checklistType (optional) 
   * @return Success
   */
  checklists_GetAll(checklistType?: ChecklistType | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistDto[]> {
    let url_ = this.baseUrl + "/api/Checklists?";
    if (checklistType === null)
      throw new Error("The parameter 'checklistType' cannot be null.");
    else if (checklistType !== undefined)
      url_ += "checklistType=" + encodeURIComponent("" + checklistType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_GetAll(_response);
    });
  }

  protected processChecklists_GetAll(response: AxiosResponse): Promise<ChecklistDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ChecklistDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto[]>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklists_Post(body?: ChecklistDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistDto> {
    let url_ = this.baseUrl + "/api/Checklists";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_Post(_response);
    });
  }

  protected processChecklists_Post(response: AxiosResponse): Promise<ChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto>(<any>null);
  }

  /**
   * @param details (optional) 
   * @return Success
   */
  checklists_GetById(id: number, details?: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistDto> {
    let url_ = this.baseUrl + "/api/Checklists/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (details === null)
      throw new Error("The parameter 'details' cannot be null.");
    else if (details !== undefined)
      url_ += "details=" + encodeURIComponent("" + details) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_GetById(_response);
    });
  }

  protected processChecklists_GetById(response: AxiosResponse): Promise<ChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklists_Put(id: number, body?: ChecklistDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Checklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_Put(_response);
    });
  }

  protected processChecklists_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklists_Patch(id: number, body?: Operation[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistDto> {
    let url_ = this.baseUrl + "/api/Checklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_Patch(_response);
    });
  }

  protected processChecklists_Patch(response: AxiosResponse): Promise<ChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto>(<any>null);
  }

  /**
   * @return Success
   */
  checklists_Delete(id: number, cancelToken?: CancelToken | undefined): Promise<ChecklistDto> {
    let url_ = this.baseUrl + "/api/Checklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_Delete(_response);
    });
  }

  protected processChecklists_Delete(response: AxiosResponse): Promise<ChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto>(<any>null);
  }

  /**
   * @param newChecklistName (optional) 
   * @return Success
   */
  checklists_CreateTemplateFromChecklist(id: number, newChecklistName?: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<RepetitiveChecklistDto> {
    let url_ = this.baseUrl + "/api/Checklists/{id}/template?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (newChecklistName !== undefined && newChecklistName !== null)
      url_ += "newChecklistName=" + encodeURIComponent("" + newChecklistName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_CreateTemplateFromChecklist(_response);
    });
  }

  protected processChecklists_CreateTemplateFromChecklist(response: AxiosResponse): Promise<RepetitiveChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RepetitiveChecklistDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto>(<any>null);
  }

  /**
   * @return Success
   */
  dWMachine_GetAll(cancelToken?: CancelToken | undefined): Promise<MachineDto[]> {
    let url_ = this.baseUrl + "/api/DWMachine";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDWMachine_GetAll(_response);
    });
  }

  protected processDWMachine_GetAll(response: AxiosResponse): Promise<MachineDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(MachineDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<MachineDto[]>(<any>null);
  }

  /**
   * @return Success
   */
  dWMachine_Get(facilityCode: string | null, cancelToken?: CancelToken | undefined): Promise<MachineDto[]> {
    let url_ = this.baseUrl + "/api/DWMachine/{facilityCode}";
    if (facilityCode === undefined || facilityCode === null)
      throw new Error("The parameter 'facilityCode' must be defined.");
    url_ = url_.replace("{facilityCode}", encodeURIComponent("" + facilityCode));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDWMachine_Get(_response);
    });
  }

  protected processDWMachine_Get(response: AxiosResponse): Promise<MachineDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(MachineDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<MachineDto[]>(<any>null);
  }

  /**
   * @return Success
   */
  dWPlant_GetAll(cancelToken?: CancelToken | undefined): Promise<FacilityDto[]> {
    let url_ = this.baseUrl + "/api/DWPlant";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDWPlant_GetAll(_response);
    });
  }

  protected processDWPlant_GetAll(response: AxiosResponse): Promise<FacilityDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(FacilityDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FacilityDto[]>(<any>null);
  }

  /**
   * @return Success
   */
  dWPlant_GetByFacilityCode(facilityCode: string | null, cancelToken?: CancelToken | undefined): Promise<FacilityDto> {
    let url_ = this.baseUrl + "/api/DWPlant/{facilityCode}";
    if (facilityCode === undefined || facilityCode === null)
      throw new Error("The parameter 'facilityCode' must be defined.");
    url_ = url_.replace("{facilityCode}", encodeURIComponent("" + facilityCode));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDWPlant_GetByFacilityCode(_response);
    });
  }

  protected processDWPlant_GetByFacilityCode(response: AxiosResponse): Promise<FacilityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = FacilityDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FacilityDto>(<any>null);
  }

  /**
   * @param includeArchived (optional) 
   * @return Success
   */
  facilities_GetAll(includeArchived?: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<FacilityDto[]> {
    let url_ = this.baseUrl + "/api/Facilities?";
    if (includeArchived === null)
      throw new Error("The parameter 'includeArchived' cannot be null.");
    else if (includeArchived !== undefined)
      url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processFacilities_GetAll(_response);
    });
  }

  protected processFacilities_GetAll(response: AxiosResponse): Promise<FacilityDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(FacilityDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FacilityDto[]>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  facilities_Post(body?: FacilityDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<FacilityDto> {
    let url_ = this.baseUrl + "/api/Facilities";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processFacilities_Post(_response);
    });
  }

  protected processFacilities_Post(response: AxiosResponse): Promise<FacilityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = FacilityDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FacilityDto>(<any>null);
  }

  /**
   * @return Success
   */
  facilities_GetByFacilityCode(facilityCode: string | null, cancelToken?: CancelToken | undefined): Promise<FacilityDto> {
    let url_ = this.baseUrl + "/api/Facilities/{facilityCode}";
    if (facilityCode === undefined || facilityCode === null)
      throw new Error("The parameter 'facilityCode' must be defined.");
    url_ = url_.replace("{facilityCode}", encodeURIComponent("" + facilityCode));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processFacilities_GetByFacilityCode(_response);
    });
  }

  protected processFacilities_GetByFacilityCode(response: AxiosResponse): Promise<FacilityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = FacilityDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FacilityDto>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  facilities_Put(facilityCode: string | null, body?: FacilityDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Facilities/{facilityCode}";
    if (facilityCode === undefined || facilityCode === null)
      throw new Error("The parameter 'facilityCode' must be defined.");
    url_ = url_.replace("{facilityCode}", encodeURIComponent("" + facilityCode));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processFacilities_Put(_response);
    });
  }

  protected processFacilities_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  facilities_Patch(facilityCode: string | null, body?: Operation[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Facilities/{facilityCode}";
    if (facilityCode === undefined || facilityCode === null)
      throw new Error("The parameter 'facilityCode' must be defined.");
    url_ = url_.replace("{facilityCode}", encodeURIComponent("" + facilityCode));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processFacilities_Patch(_response);
    });
  }

  protected processFacilities_Patch(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param questionId (optional) 
   * @param projectId (optional) 
   * @return Success
   */
  issues_GetAll(questionId?: number | null | undefined, projectId?: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<IssueDto[]> {
    let url_ = this.baseUrl + "/api/Issues?";
    if (questionId !== undefined && questionId !== null)
      url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
    if (projectId !== undefined && projectId !== null)
      url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_GetAll(_response);
    });
  }

  protected processIssues_GetAll(response: AxiosResponse): Promise<IssueDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(IssueDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<IssueDto[]>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  issues_Post(body?: IssueDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<IssueDto> {
    let url_ = this.baseUrl + "/api/Issues";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_Post(_response);
    });
  }

  protected processIssues_Post(response: AxiosResponse): Promise<IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = IssueDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<IssueDto>(<any>null);
  }

  /**
   * @return Success
   */
  issues_GetById(id: number, cancelToken?: CancelToken | undefined): Promise<IssueDto> {
    let url_ = this.baseUrl + "/api/Issues/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_GetById(_response);
    });
  }

  protected processIssues_GetById(response: AxiosResponse): Promise<IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = IssueDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<IssueDto>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  issues_Put(id: number, body?: IssueDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Issues/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_Put(_response);
    });
  }

  protected processIssues_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  issues_Patch(id: number, body?: Operation[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<IssueDto> {
    let url_ = this.baseUrl + "/api/Issues/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_Patch(_response);
    });
  }

  protected processIssues_Patch(response: AxiosResponse): Promise<IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = IssueDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<IssueDto>(<any>null);
  }

  /**
   * @return Success
   */
  issues_Delete(id: number, cancelToken?: CancelToken | undefined): Promise<IssueDto> {
    let url_ = this.baseUrl + "/api/Issues/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_Delete(_response);
    });
  }

  protected processIssues_Delete(response: AxiosResponse): Promise<IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = IssueDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<IssueDto>(<any>null);
  }

  /**
   * @return Success
   */
  lookupLists_GetAll(cancelToken?: CancelToken | undefined): Promise<LookupListDto[]> {
    let url_ = this.baseUrl + "/api/LookupLists";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_GetAll(_response);
    });
  }

  protected processLookupLists_GetAll(response: AxiosResponse): Promise<LookupListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(LookupListDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LookupListDto[]>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  lookupLists_Post(body?: LookupListDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<LookupListDto> {
    let url_ = this.baseUrl + "/api/LookupLists";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_Post(_response);
    });
  }

  protected processLookupLists_Post(response: AxiosResponse): Promise<LookupListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = LookupListDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LookupListDto>(<any>null);
  }

  /**
   * @return Success
   */
  lookupLists_GetById(id: number, cancelToken?: CancelToken | undefined): Promise<LookupListDto> {
    let url_ = this.baseUrl + "/api/LookupLists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_GetById(_response);
    });
  }

  protected processLookupLists_GetById(response: AxiosResponse): Promise<LookupListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = LookupListDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LookupListDto>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  lookupLists_Put(id: number, body?: LookupListDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/LookupLists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_Put(_response);
    });
  }

  protected processLookupLists_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  lookupLists_Patch(id: number, body?: Operation[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/LookupLists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_Patch(_response);
    });
  }

  protected processLookupLists_Patch(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  lookupLists_Delete(id: number, cancelToken?: CancelToken | undefined): Promise<LookupListDto> {
    let url_ = this.baseUrl + "/api/LookupLists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_Delete(_response);
    });
  }

  protected processLookupLists_Delete(response: AxiosResponse): Promise<LookupListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = LookupListDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LookupListDto>(<any>null);
  }

  /**
   * @return Success
   */
  moreInfo_GetAll(cancelToken?: CancelToken | undefined): Promise<QuestionMoreInfoDto[]> {
    let url_ = this.baseUrl + "/api/MoreInfo";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_GetAll(_response);
    });
  }

  protected processMoreInfo_GetAll(response: AxiosResponse): Promise<QuestionMoreInfoDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(QuestionMoreInfoDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionMoreInfoDto[]>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  moreInfo_Post(body?: QuestionMoreInfoDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<QuestionMoreInfoDto> {
    let url_ = this.baseUrl + "/api/MoreInfo";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_Post(_response);
    });
  }

  protected processMoreInfo_Post(response: AxiosResponse): Promise<QuestionMoreInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionMoreInfoDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionMoreInfoDto>(<any>null);
  }

  /**
   * @return Success
   */
  moreInfo_GetById(id: number, cancelToken?: CancelToken | undefined): Promise<QuestionMoreInfoDto> {
    let url_ = this.baseUrl + "/api/MoreInfo/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_GetById(_response);
    });
  }

  protected processMoreInfo_GetById(response: AxiosResponse): Promise<QuestionMoreInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionMoreInfoDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionMoreInfoDto>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  moreInfo_Put(id: number, body?: QuestionMoreInfoDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/MoreInfo/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_Put(_response);
    });
  }

  protected processMoreInfo_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  moreInfo_Patch(id: number, body?: Operation[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/MoreInfo/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_Patch(_response);
    });
  }

  protected processMoreInfo_Patch(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  moreInfo_Delete(id: number, cancelToken?: CancelToken | undefined): Promise<QuestionMoreInfoDto> {
    let url_ = this.baseUrl + "/api/MoreInfo/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_Delete(_response);
    });
  }

  protected processMoreInfo_Delete(response: AxiosResponse): Promise<QuestionMoreInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionMoreInfoDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionMoreInfoDto>(<any>null);
  }

  /**
   * @param areaId (optional) 
   * @return Success
   */
  questions_GetAll(areaId?: number | undefined, cancelToken?: CancelToken | undefined): Promise<QuestionDto[]> {
    let url_ = this.baseUrl + "/api/Questions?";
    if (areaId === null)
      throw new Error("The parameter 'areaId' cannot be null.");
    else if (areaId !== undefined)
      url_ += "areaId=" + encodeURIComponent("" + areaId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_GetAll(_response);
    });
  }

  protected processQuestions_GetAll(response: AxiosResponse): Promise<QuestionDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(QuestionDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionDto[]>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  questions_Post(body?: QuestionDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/api/Questions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_Post(_response);
    });
  }

  protected processQuestions_Post(response: AxiosResponse): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionDto>(<any>null);
  }

  /**
   * @return Success
   */
  questions_GetById(id: number, cancelToken?: CancelToken | undefined): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/api/Questions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_GetById(_response);
    });
  }

  protected processQuestions_GetById(response: AxiosResponse): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionDto>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  questions_Put(id: number, body?: QuestionDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Questions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_Put(_response);
    });
  }

  protected processQuestions_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  questions_Patch(id: number, body?: Operation[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/api/Questions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_Patch(_response);
    });
  }

  protected processQuestions_Patch(response: AxiosResponse): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionDto>(<any>null);
  }

  /**
   * @return Success
   */
  questions_Delete(id: number, cancelToken?: CancelToken | undefined): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/api/Questions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_Delete(_response);
    });
  }

  protected processQuestions_Delete(response: AxiosResponse): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionDto>(<any>null);
  }

  /**
   * @param facilityCode (optional) 
   * @param projectType (optional) 
   * @param checklistType (optional) 
   * @param archived (optional) 
   * @return Success
   */
  repetitiveChecklists_GetAll(facilityCode?: string | null | undefined, projectType?: ChecklistProjectType | null | undefined, checklistType?: ChecklistType | null | undefined, archived?: boolean | null | undefined, cancelToken?: CancelToken | undefined): Promise<RepetitiveChecklistDto[]> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists?";
    if (facilityCode !== undefined && facilityCode !== null)
      url_ += "facilityCode=" + encodeURIComponent("" + facilityCode) + "&";
    if (projectType !== undefined && projectType !== null)
      url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
    if (checklistType !== undefined && checklistType !== null)
      url_ += "checklistType=" + encodeURIComponent("" + checklistType) + "&";
    if (archived !== undefined && archived !== null)
      url_ += "archived=" + encodeURIComponent("" + archived) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_GetAll(_response);
    });
  }

  protected processRepetitiveChecklists_GetAll(response: AxiosResponse): Promise<RepetitiveChecklistDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(RepetitiveChecklistDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto[]>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  repetitiveChecklists_Post(body?: RepetitiveChecklistDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<RepetitiveChecklistDto> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_Post(_response);
    });
  }

  protected processRepetitiveChecklists_Post(response: AxiosResponse): Promise<RepetitiveChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RepetitiveChecklistDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto>(<any>null);
  }

  /**
   * @param details (optional) 
   * @return Success
   */
  repetitiveChecklists_GetById(id: number, details?: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<RepetitiveChecklistDto> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (details === null)
      throw new Error("The parameter 'details' cannot be null.");
    else if (details !== undefined)
      url_ += "details=" + encodeURIComponent("" + details) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_GetById(_response);
    });
  }

  protected processRepetitiveChecklists_GetById(response: AxiosResponse): Promise<RepetitiveChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RepetitiveChecklistDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  repetitiveChecklists_Put(id: number, body?: RepetitiveChecklistDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_Put(_response);
    });
  }

  protected processRepetitiveChecklists_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  repetitiveChecklists_Patch(id: number, body?: Operation[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_Patch(_response);
    });
  }

  protected processRepetitiveChecklists_Patch(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  repetitiveChecklists_Delete(id: number, cancelToken?: CancelToken | undefined): Promise<RepetitiveChecklistDto> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_Delete(_response);
    });
  }

  protected processRepetitiveChecklists_Delete(response: AxiosResponse): Promise<RepetitiveChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RepetitiveChecklistDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto>(<any>null);
  }

  /**
   * @param projectId (optional) 
   * @param newChecklistName (optional) 
   * @param newType (optional) 
   * @return Success
   */
  repetitiveChecklists_CopyChecklistToProject(id: number, projectId?: number | undefined, newChecklistName?: string | null | undefined, newType?: ChecklistType | undefined, cancelToken?: CancelToken | undefined): Promise<ChecklistDto> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}/copyto?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (projectId === null)
      throw new Error("The parameter 'projectId' cannot be null.");
    else if (projectId !== undefined)
      url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
    if (newChecklistName !== undefined && newChecklistName !== null)
      url_ += "newChecklistName=" + encodeURIComponent("" + newChecklistName) + "&";
    if (newType === null)
      throw new Error("The parameter 'newType' cannot be null.");
    else if (newType !== undefined)
      url_ += "newType=" + encodeURIComponent("" + newType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_CopyChecklistToProject(_response);
    });
  }

  protected processRepetitiveChecklists_CopyChecklistToProject(response: AxiosResponse): Promise<ChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto>(<any>null);
  }

  /**
   * @param newChecklistName (optional) 
   * @return Success
   */
  repetitiveChecklists_DuplicateRepetitiveChecklist(id: number, newChecklistName?: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<RepetitiveChecklistDto> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}/duplicate?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (newChecklistName !== undefined && newChecklistName !== null)
      url_ += "newChecklistName=" + encodeURIComponent("" + newChecklistName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_DuplicateRepetitiveChecklist(_response);
    });
  }

  protected processRepetitiveChecklists_DuplicateRepetitiveChecklist(response: AxiosResponse): Promise<RepetitiveChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RepetitiveChecklistDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto>(<any>null);
  }

  /**
   * @return Success
   */
  users_GetAll(cancelToken?: CancelToken | undefined): Promise<UserDto[]> {
    let url_ = this.baseUrl + "/api/Users";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUsers_GetAll(_response);
    });
  }

  protected processUsers_GetAll(response: AxiosResponse): Promise<UserDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UserDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UserDto[]>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  users_Post(body?: UserDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<UserDto> {
    let url_ = this.baseUrl + "/api/Users";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUsers_Post(_response);
    });
  }

  protected processUsers_Post(response: AxiosResponse): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UserDto>(<any>null);
  }

  /**
   * @return Success
   */
  users_GetById(id: number, cancelToken?: CancelToken | undefined): Promise<UserDto> {
    let url_ = this.baseUrl + "/api/Users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUsers_GetById(_response);
    });
  }

  protected processUsers_GetById(response: AxiosResponse): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UserDto>(<any>null);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  users_Put(id: number, body?: UserDto | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + "/api/Users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUsers_Put(_response);
    });
  }

  protected processUsers_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  users_Delete(id: number, cancelToken?: CancelToken | undefined): Promise<UserDto> {
    let url_ = this.baseUrl + "/api/Users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUsers_Delete(_response);
    });
  }

  protected processUsers_Delete(response: AxiosResponse): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UserDto>(<any>null);
  }
}

export class LoginCredentials implements ILoginCredentials {
  username?: string | null;
  password?: string | null;

  constructor(data?: ILoginCredentials) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
      this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
    }
  }

  static fromJS(data: any): LoginCredentials {
    data = typeof data === 'object' ? data : {};
    let result = new LoginCredentials();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["username"] = this.username !== undefined ? this.username : <any>null;
    data["password"] = this.password !== undefined ? this.password : <any>null;
    return data;
  }
}

export interface ILoginCredentials {
  username?: string | null;
  password?: string | null;
}

export enum QuestionType {
  YesNo = "yesNo",
  YesNoNA = "yesNoNA",
  Textbox = "textbox",
  LookupList = "lookupList",
}

export class IssueDto implements IIssueDto {
  id?: number;
  questionId?: number;
  notes?: string | null;
  readonly imageUrl?: string | null;
  imageData?: string | null;
  resolved?: boolean;
  readonly createdBy?: string | null;
  readonly createdOn?: moment.Moment;
  readonly updatedBy?: string | null;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IIssueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.questionId = _data["questionId"] !== undefined ? _data["questionId"] : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      (<any>this).imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
      this.imageData = _data["imageData"] !== undefined ? _data["imageData"] : <any>null;
      this.resolved = _data["resolved"] !== undefined ? _data["resolved"] : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): IssueDto {
    data = typeof data === 'object' ? data : {};
    let result = new IssueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["questionId"] = this.questionId !== undefined ? this.questionId : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
    data["imageData"] = this.imageData !== undefined ? this.imageData : <any>null;
    data["resolved"] = this.resolved !== undefined ? this.resolved : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IIssueDto {
  id?: number;
  questionId?: number;
  notes?: string | null;
  imageUrl?: string | null;
  imageData?: string | null;
  resolved?: boolean;
  createdBy?: string | null;
  createdOn?: moment.Moment;
  updatedBy?: string | null;
  updatedOn?: moment.Moment;
}

export class QuestionDto implements IQuestionDto {
  id?: number | null;
  areaId?: number | null;
  prompt?: string | null;
  hint?: string | null;
  type!: QuestionType;
  lookupListId?: number | null;
  sortOrder?: number;
  value?: number | null;
  textValue?: string | null;
  conditions?: string | null;
  issues?: IssueDto[] | null;
  moreInfoId?: number | null;
  readonly createdBy?: string | null;
  readonly createdOn?: moment.Moment;
  readonly updatedBy?: string | null;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IQuestionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : <any>null;
      this.prompt = _data["prompt"] !== undefined ? _data["prompt"] : <any>null;
      this.hint = _data["hint"] !== undefined ? _data["hint"] : <any>null;
      this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      this.lookupListId = _data["lookupListId"] !== undefined ? _data["lookupListId"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
      this.textValue = _data["textValue"] !== undefined ? _data["textValue"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
      if (Array.isArray(_data["issues"])) {
        this.issues = [] as any;
        for (let item of _data["issues"])
          this.issues!.push(IssueDto.fromJS(item));
      }
      this.moreInfoId = _data["moreInfoId"] !== undefined ? _data["moreInfoId"] : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): QuestionDto {
    data = typeof data === 'object' ? data : {};
    let result = new QuestionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["areaId"] = this.areaId !== undefined ? this.areaId : <any>null;
    data["prompt"] = this.prompt !== undefined ? this.prompt : <any>null;
    data["hint"] = this.hint !== undefined ? this.hint : <any>null;
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["lookupListId"] = this.lookupListId !== undefined ? this.lookupListId : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    data["value"] = this.value !== undefined ? this.value : <any>null;
    data["textValue"] = this.textValue !== undefined ? this.textValue : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    if (Array.isArray(this.issues)) {
      data["issues"] = [];
      for (let item of this.issues)
        data["issues"].push(item.toJSON());
    }
    data["moreInfoId"] = this.moreInfoId !== undefined ? this.moreInfoId : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IQuestionDto {
  id?: number | null;
  areaId?: number | null;
  prompt?: string | null;
  hint?: string | null;
  type: QuestionType;
  lookupListId?: number | null;
  sortOrder?: number;
  value?: number | null;
  textValue?: string | null;
  conditions?: string | null;
  issues?: IssueDto[] | null;
  moreInfoId?: number | null;
  createdBy?: string | null;
  createdOn?: moment.Moment;
  updatedBy?: string | null;
  updatedOn?: moment.Moment;
}

export class ChecklistAreaDto implements IChecklistAreaDto {
  id?: number;
  checklistId?: number | null;
  repetitiveChecklistId?: number | null;
  name!: string;
  description?: string | null;
  questions?: QuestionDto[] | null;
  sortOrder?: number;
  conditions?: string | null;

  constructor(data?: IChecklistAreaDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.checklistId = _data["checklistId"] !== undefined ? _data["checklistId"] : <any>null;
      this.repetitiveChecklistId = _data["repetitiveChecklistId"] !== undefined ? _data["repetitiveChecklistId"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
      if (Array.isArray(_data["questions"])) {
        this.questions = [] as any;
        for (let item of _data["questions"])
          this.questions!.push(QuestionDto.fromJS(item));
      }
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
    }
  }

  static fromJS(data: any): ChecklistAreaDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChecklistAreaDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["checklistId"] = this.checklistId !== undefined ? this.checklistId : <any>null;
    data["repetitiveChecklistId"] = this.repetitiveChecklistId !== undefined ? this.repetitiveChecklistId : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] = this.description !== undefined ? this.description : <any>null;
    if (Array.isArray(this.questions)) {
      data["questions"] = [];
      for (let item of this.questions)
        data["questions"].push(item.toJSON());
    }
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    return data;
  }
}

export interface IChecklistAreaDto {
  id?: number;
  checklistId?: number | null;
  repetitiveChecklistId?: number | null;
  name: string;
  description?: string | null;
  questions?: QuestionDto[] | null;
  sortOrder?: number;
  conditions?: string | null;
}

export class Operation implements IOperation {
  value?: any | null;
  path?: string | null;
  op?: string | null;
  from?: string | null;

  constructor(data?: IOperation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
      this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
      this.op = _data["op"] !== undefined ? _data["op"] : <any>null;
      this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
    }
  }

  static fromJS(data: any): Operation {
    data = typeof data === 'object' ? data : {};
    let result = new Operation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["value"] = this.value !== undefined ? this.value : <any>null;
    data["path"] = this.path !== undefined ? this.path : <any>null;
    data["op"] = this.op !== undefined ? this.op : <any>null;
    data["from"] = this.from !== undefined ? this.from : <any>null;
    return data;
  }
}

export interface IOperation {
  value?: any | null;
  path?: string | null;
  op?: string | null;
  from?: string | null;
}

export enum ChecklistProjectType {
  Simple = "simple",
  Engineering = "engineering",
  Machining = "machining",
  MoldMaking = "moldMaking",
}

export enum ChecklistType {
  Standard = "standard",
  Repetitive = "repetitive",
  Cavity = "cavity",
  Core = "core",
}

export class ChecklistDto implements IChecklistDto {
  id?: number;
  projectId?: number | null;
  type!: ChecklistType;
  name!: string;
  description?: string | null;
  sortOrder?: number;
  options?: string | null;
  areas?: ChecklistAreaDto[] | null;
  hidden?: boolean;
  allowSignOff?: boolean | null;
  readonly signOffUserId?: number | null;
  readonly signOffUserUserName?: string | null;
  signOffAt?: moment.Moment | null;
  signOffNotes?: string | null;
  machineId?: string | null;
  machineName?: string | null;
  component?: string | null;
  userEditableName?: boolean | null;
  readonly createdBy?: string | null;
  readonly createdOn?: moment.Moment;
  readonly updatedBy?: string | null;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IChecklistDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
      this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      this.options = _data["options"] !== undefined ? _data["options"] : <any>null;
      if (Array.isArray(_data["areas"])) {
        this.areas = [] as any;
        for (let item of _data["areas"])
          this.areas!.push(ChecklistAreaDto.fromJS(item));
      }
      this.hidden = _data["hidden"] !== undefined ? _data["hidden"] : <any>null;
      this.allowSignOff = _data["allowSignOff"] !== undefined ? _data["allowSignOff"] : <any>null;
      (<any>this).signOffUserId = _data["signOffUserId"] !== undefined ? _data["signOffUserId"] : <any>null;
      (<any>this).signOffUserUserName = _data["signOffUserUserName"] !== undefined ? _data["signOffUserUserName"] : <any>null;
      this.signOffAt = _data["signOffAt"] ? moment(_data["signOffAt"].toString()) : <any>null;
      this.signOffNotes = _data["signOffNotes"] !== undefined ? _data["signOffNotes"] : <any>null;
      this.machineId = _data["machineId"] !== undefined ? _data["machineId"] : <any>null;
      this.machineName = _data["machineName"] !== undefined ? _data["machineName"] : <any>null;
      this.component = _data["component"] !== undefined ? _data["component"] : <any>null;
      this.userEditableName = _data["userEditableName"] !== undefined ? _data["userEditableName"] : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): ChecklistDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChecklistDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] = this.description !== undefined ? this.description : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    data["options"] = this.options !== undefined ? this.options : <any>null;
    if (Array.isArray(this.areas)) {
      data["areas"] = [];
      for (let item of this.areas)
        data["areas"].push(item.toJSON());
    }
    data["hidden"] = this.hidden !== undefined ? this.hidden : <any>null;
    data["allowSignOff"] = this.allowSignOff !== undefined ? this.allowSignOff : <any>null;
    data["signOffUserId"] = this.signOffUserId !== undefined ? this.signOffUserId : <any>null;
    data["signOffUserUserName"] = this.signOffUserUserName !== undefined ? this.signOffUserUserName : <any>null;
    data["signOffAt"] = this.signOffAt ? this.signOffAt.toISOString() : <any>null;
    data["signOffNotes"] = this.signOffNotes !== undefined ? this.signOffNotes : <any>null;
    data["machineId"] = this.machineId !== undefined ? this.machineId : <any>null;
    data["machineName"] = this.machineName !== undefined ? this.machineName : <any>null;
    data["component"] = this.component !== undefined ? this.component : <any>null;
    data["userEditableName"] = this.userEditableName !== undefined ? this.userEditableName : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IChecklistDto {
  id?: number;
  projectId?: number | null;
  type: ChecklistType;
  name: string;
  description?: string | null;
  sortOrder?: number;
  options?: string | null;
  areas?: ChecklistAreaDto[] | null;
  hidden?: boolean;
  allowSignOff?: boolean | null;
  signOffUserId?: number | null;
  signOffUserUserName?: string | null;
  signOffAt?: moment.Moment | null;
  signOffNotes?: string | null;
  machineId?: string | null;
  machineName?: string | null;
  component?: string | null;
  userEditableName?: boolean | null;
  createdBy?: string | null;
  createdOn?: moment.Moment;
  updatedBy?: string | null;
  updatedOn?: moment.Moment;
}

export class ChecklistProjectDto implements IChecklistProjectDto {
  id?: number;
  name!: string;
  description?: string | null;
  isTemplate?: boolean | null;
  archived?: boolean | null;
  readonly?: boolean | null;
  unresolvedIssues?: number | null;
  progress?: number | null;
  checklists?: ChecklistDto[] | null;
  projectType?: ChecklistProjectType | null;
  facilityCode?: string | null;
  projectTypesAllowed?: ChecklistProjectType[] | null;
  facilityRestrictions?: string[] | null;
  jobNum?: string | null;
  readonly createdBy?: string | null;
  readonly createdOn?: moment.Moment;
  readonly updatedBy?: string | null;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IChecklistProjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
      this.isTemplate = _data["isTemplate"] !== undefined ? _data["isTemplate"] : <any>null;
      this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
      this.readonly = _data["readonly"] !== undefined ? _data["readonly"] : <any>null;
      this.unresolvedIssues = _data["unresolvedIssues"] !== undefined ? _data["unresolvedIssues"] : <any>null;
      this.progress = _data["progress"] !== undefined ? _data["progress"] : <any>null;
      if (Array.isArray(_data["checklists"])) {
        this.checklists = [] as any;
        for (let item of _data["checklists"])
          this.checklists!.push(ChecklistDto.fromJS(item));
      }
      this.projectType = _data["projectType"] !== undefined ? _data["projectType"] : <any>null;
      this.facilityCode = _data["facilityCode"] !== undefined ? _data["facilityCode"] : <any>null;
      if (Array.isArray(_data["projectTypesAllowed"])) {
        this.projectTypesAllowed = [] as any;
        for (let item of _data["projectTypesAllowed"])
          this.projectTypesAllowed!.push(item);
      }
      if (Array.isArray(_data["facilityRestrictions"])) {
        this.facilityRestrictions = [] as any;
        for (let item of _data["facilityRestrictions"])
          this.facilityRestrictions!.push(item);
      }
      this.jobNum = _data["jobNum"] !== undefined ? _data["jobNum"] : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): ChecklistProjectDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChecklistProjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] = this.description !== undefined ? this.description : <any>null;
    data["isTemplate"] = this.isTemplate !== undefined ? this.isTemplate : <any>null;
    data["archived"] = this.archived !== undefined ? this.archived : <any>null;
    data["readonly"] = this.readonly !== undefined ? this.readonly : <any>null;
    data["unresolvedIssues"] = this.unresolvedIssues !== undefined ? this.unresolvedIssues : <any>null;
    data["progress"] = this.progress !== undefined ? this.progress : <any>null;
    if (Array.isArray(this.checklists)) {
      data["checklists"] = [];
      for (let item of this.checklists)
        data["checklists"].push(item.toJSON());
    }
    data["projectType"] = this.projectType !== undefined ? this.projectType : <any>null;
    data["facilityCode"] = this.facilityCode !== undefined ? this.facilityCode : <any>null;
    if (Array.isArray(this.projectTypesAllowed)) {
      data["projectTypesAllowed"] = [];
      for (let item of this.projectTypesAllowed)
        data["projectTypesAllowed"].push(item);
    }
    if (Array.isArray(this.facilityRestrictions)) {
      data["facilityRestrictions"] = [];
      for (let item of this.facilityRestrictions)
        data["facilityRestrictions"].push(item);
    }
    data["jobNum"] = this.jobNum !== undefined ? this.jobNum : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IChecklistProjectDto {
  id?: number;
  name: string;
  description?: string | null;
  isTemplate?: boolean | null;
  archived?: boolean | null;
  readonly?: boolean | null;
  unresolvedIssues?: number | null;
  progress?: number | null;
  checklists?: ChecklistDto[] | null;
  projectType?: ChecklistProjectType | null;
  facilityCode?: string | null;
  projectTypesAllowed?: ChecklistProjectType[] | null;
  facilityRestrictions?: string[] | null;
  jobNum?: string | null;
  createdBy?: string | null;
  createdOn?: moment.Moment;
  updatedBy?: string | null;
  updatedOn?: moment.Moment;
}

export class SnlrHeaders implements ISnlrHeaders {
  snlrConnectionId?: string | null;
  snlrGroupId?: string | null;
  readonly hasGroupId?: boolean;
  readonly hasConnectionId?: boolean;

  constructor(data?: ISnlrHeaders) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.snlrConnectionId = _data["snlrConnectionId"] !== undefined ? _data["snlrConnectionId"] : <any>null;
      this.snlrGroupId = _data["snlrGroupId"] !== undefined ? _data["snlrGroupId"] : <any>null;
      (<any>this).hasGroupId = _data["hasGroupId"] !== undefined ? _data["hasGroupId"] : <any>null;
      (<any>this).hasConnectionId = _data["hasConnectionId"] !== undefined ? _data["hasConnectionId"] : <any>null;
    }
  }

  static fromJS(data: any): SnlrHeaders {
    data = typeof data === 'object' ? data : {};
    let result = new SnlrHeaders();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["snlrConnectionId"] = this.snlrConnectionId !== undefined ? this.snlrConnectionId : <any>null;
    data["snlrGroupId"] = this.snlrGroupId !== undefined ? this.snlrGroupId : <any>null;
    data["hasGroupId"] = this.hasGroupId !== undefined ? this.hasGroupId : <any>null;
    data["hasConnectionId"] = this.hasConnectionId !== undefined ? this.hasConnectionId : <any>null;
    return data;
  }
}

export interface ISnlrHeaders {
  snlrConnectionId?: string | null;
  snlrGroupId?: string | null;
  hasGroupId?: boolean;
  hasConnectionId?: boolean;
}

export class RepetitiveChecklistDto implements IRepetitiveChecklistDto {
  id?: number;
  name!: string;
  description?: string | null;
  sortOrder?: number;
  options?: string | null;
  areas?: ChecklistAreaDto[] | null;
  projectTypesAllowed?: ChecklistProjectType[] | null;
  checklistTypes?: ChecklistType[] | null;
  facilityRestrictions?: string[] | null;
  archived?: boolean;
  allowSignOff?: boolean | null;
  useSuggestions?: boolean;
  suggestionsLabel?: string | null;
  suggestions?: string[] | null;
  customSuggestions?: boolean | null;
  defaultNameFormat?: string | null;
  userEditableName?: boolean | null;

  constructor(data?: IRepetitiveChecklistDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      this.options = _data["options"] !== undefined ? _data["options"] : <any>null;
      if (Array.isArray(_data["areas"])) {
        this.areas = [] as any;
        for (let item of _data["areas"])
          this.areas!.push(ChecklistAreaDto.fromJS(item));
      }
      if (Array.isArray(_data["projectTypesAllowed"])) {
        this.projectTypesAllowed = [] as any;
        for (let item of _data["projectTypesAllowed"])
          this.projectTypesAllowed!.push(item);
      }
      if (Array.isArray(_data["checklistTypes"])) {
        this.checklistTypes = [] as any;
        for (let item of _data["checklistTypes"])
          this.checklistTypes!.push(item);
      }
      if (Array.isArray(_data["facilityRestrictions"])) {
        this.facilityRestrictions = [] as any;
        for (let item of _data["facilityRestrictions"])
          this.facilityRestrictions!.push(item);
      }
      this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
      this.allowSignOff = _data["allowSignOff"] !== undefined ? _data["allowSignOff"] : <any>null;
      this.useSuggestions = _data["useSuggestions"] !== undefined ? _data["useSuggestions"] : <any>null;
      this.suggestionsLabel = _data["suggestionsLabel"] !== undefined ? _data["suggestionsLabel"] : <any>null;
      if (Array.isArray(_data["suggestions"])) {
        this.suggestions = [] as any;
        for (let item of _data["suggestions"])
          this.suggestions!.push(item);
      }
      this.customSuggestions = _data["customSuggestions"] !== undefined ? _data["customSuggestions"] : <any>null;
      this.defaultNameFormat = _data["defaultNameFormat"] !== undefined ? _data["defaultNameFormat"] : <any>null;
      this.userEditableName = _data["userEditableName"] !== undefined ? _data["userEditableName"] : <any>null;
    }
  }

  static fromJS(data: any): RepetitiveChecklistDto {
    data = typeof data === 'object' ? data : {};
    let result = new RepetitiveChecklistDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] = this.description !== undefined ? this.description : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    data["options"] = this.options !== undefined ? this.options : <any>null;
    if (Array.isArray(this.areas)) {
      data["areas"] = [];
      for (let item of this.areas)
        data["areas"].push(item.toJSON());
    }
    if (Array.isArray(this.projectTypesAllowed)) {
      data["projectTypesAllowed"] = [];
      for (let item of this.projectTypesAllowed)
        data["projectTypesAllowed"].push(item);
    }
    if (Array.isArray(this.checklistTypes)) {
      data["checklistTypes"] = [];
      for (let item of this.checklistTypes)
        data["checklistTypes"].push(item);
    }
    if (Array.isArray(this.facilityRestrictions)) {
      data["facilityRestrictions"] = [];
      for (let item of this.facilityRestrictions)
        data["facilityRestrictions"].push(item);
    }
    data["archived"] = this.archived !== undefined ? this.archived : <any>null;
    data["allowSignOff"] = this.allowSignOff !== undefined ? this.allowSignOff : <any>null;
    data["useSuggestions"] = this.useSuggestions !== undefined ? this.useSuggestions : <any>null;
    data["suggestionsLabel"] = this.suggestionsLabel !== undefined ? this.suggestionsLabel : <any>null;
    if (Array.isArray(this.suggestions)) {
      data["suggestions"] = [];
      for (let item of this.suggestions)
        data["suggestions"].push(item);
    }
    data["customSuggestions"] = this.customSuggestions !== undefined ? this.customSuggestions : <any>null;
    data["defaultNameFormat"] = this.defaultNameFormat !== undefined ? this.defaultNameFormat : <any>null;
    data["userEditableName"] = this.userEditableName !== undefined ? this.userEditableName : <any>null;
    return data;
  }
}

export interface IRepetitiveChecklistDto {
  id?: number;
  name: string;
  description?: string | null;
  sortOrder?: number;
  options?: string | null;
  areas?: ChecklistAreaDto[] | null;
  projectTypesAllowed?: ChecklistProjectType[] | null;
  checklistTypes?: ChecklistType[] | null;
  facilityRestrictions?: string[] | null;
  archived?: boolean;
  allowSignOff?: boolean | null;
  useSuggestions?: boolean;
  suggestionsLabel?: string | null;
  suggestions?: string[] | null;
  customSuggestions?: boolean | null;
  defaultNameFormat?: string | null;
  userEditableName?: boolean | null;
}

export class MachineDto implements IMachineDto {
  id?: string | null;
  name?: string | null;

  constructor(data?: IMachineDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
    }
  }

  static fromJS(data: any): MachineDto {
    data = typeof data === 'object' ? data : {};
    let result = new MachineDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    return data;
  }
}

export interface IMachineDto {
  id?: string | null;
  name?: string | null;
}

export class FacilityDto implements IFacilityDto {
  code!: string;
  name!: string;
  archived?: boolean;

  constructor(data?: IFacilityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
    }
  }

  static fromJS(data: any): FacilityDto {
    data = typeof data === 'object' ? data : {};
    let result = new FacilityDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["code"] = this.code !== undefined ? this.code : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["archived"] = this.archived !== undefined ? this.archived : <any>null;
    return data;
  }
}

export interface IFacilityDto {
  code: string;
  name: string;
  archived?: boolean;
}

export class LookupListDto implements ILookupListDto {
  id?: number;
  name!: string;
  description?: string | null;
  options?: string | null;

  constructor(data?: ILookupListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
      this.options = _data["options"] !== undefined ? _data["options"] : <any>null;
    }
  }

  static fromJS(data: any): LookupListDto {
    data = typeof data === 'object' ? data : {};
    let result = new LookupListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] = this.description !== undefined ? this.description : <any>null;
    data["options"] = this.options !== undefined ? this.options : <any>null;
    return data;
  }
}

export interface ILookupListDto {
  id?: number;
  name: string;
  description?: string | null;
  options?: string | null;
}

export class QuestionMoreInfoDto implements IQuestionMoreInfoDto {
  id?: number;
  html_en?: string | null;

  constructor(data?: IQuestionMoreInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.html_en = _data["html_en"] !== undefined ? _data["html_en"] : <any>null;
    }
  }

  static fromJS(data: any): QuestionMoreInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new QuestionMoreInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["html_en"] = this.html_en !== undefined ? this.html_en : <any>null;
    return data;
  }
}

export interface IQuestionMoreInfoDto {
  id?: number;
  html_en?: string | null;
}

export class UserDto implements IUserDto {
  id?: number;
  userName!: string;
  newPassword?: string | null;
  name?: string | null;
  email?: string | null;
  superUser?: boolean;
  disabled?: boolean;
  readonly createdOn?: moment.Moment;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
      this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
      this.superUser = _data["superUser"] !== undefined ? _data["superUser"] : <any>null;
      this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): UserDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["userName"] = this.userName !== undefined ? this.userName : <any>null;
    data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["email"] = this.email !== undefined ? this.email : <any>null;
    data["superUser"] = this.superUser !== undefined ? this.superUser : <any>null;
    data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IUserDto {
  id?: number;
  userName: string;
  newPassword?: string | null;
  name?: string | null;
  email?: string | null;
  superUser?: boolean;
  disabled?: boolean;
  createdOn?: moment.Moment;
  updatedOn?: moment.Moment;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
  if (result !== null && result !== undefined)
    throw result;
  else
    throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}